import { createContext as t } from "react";
import { ApplicationMenu as o } from "../../utils/applicationMenu/applicationMenu.js";
const p = t(
  new o()
);
export {
  p as ApplicationMenuContext
};
